import React, { useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import styled from '@emotion/styled';
import Textfield from '@atlaskit/textfield';
import SearchIcon from '@atlaskit/icon/glyph/search';
import SelectClearIcon from '@atlaskit/icon/glyph/select-clear';
import Button from '@atlaskit/button';
import { N90 } from '@atlaskit/theme/colors';

const StyledHelperMessageLabel = styled.label({
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '16px',
  color: '#626F86',
});

const StyledSearchIconWrapper = styled.div({
  padding: '0 8px',
});

export const SearchBillingProfile = ({
  placeholder,
  helperMessage,
  onQueryChange,
  clearSearchQuery,
  isDisabled = false,
}: {
  placeholder?: string;
  helperMessage?: string;
  isDisabled?: boolean;
  onQueryChange: (_searchQuery: string) => void;
  clearSearchQuery: () => void;
}) => {
  const [searchQuery, setSearchQuery] = useState('');
  return (
    <div>
      <Textfield
        elemBeforeInput={
          isEmpty(searchQuery) ? (
            <StyledSearchIconWrapper>
              <SearchIcon testId="billing-profile-search-icon" primaryColor={N90} label="" size="small" />
            </StyledSearchIconWrapper>
          ) : (
            <></>
          )
        }
        elemAfterInput={
          isEmpty(searchQuery) ? (
            <></>
          ) : (
            <Button
              iconAfter={<SelectClearIcon testId="clear-icon-btn" primaryColor={N90} label="" size="small" />}
              onClick={() => {
                setSearchQuery('');
                clearSearchQuery();
              }}
              appearance="subtle"
            />
          )
        }
        value={searchQuery}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setSearchQuery(e.target.value);
          onQueryChange(e.target.value);
        }}
        isDisabled={isDisabled}
        placeholder={placeholder}
        testId="billing-profile-search"
      />
      {helperMessage && <StyledHelperMessageLabel>{helperMessage}</StyledHelperMessageLabel>}
    </div>
  );
};
